import { AxiosGetSecretApi } from "../../utils/fetchApi";
import {
  GET_ALL_DUONG,
  GET_ALL_LOAI_PHONG_BAN,
  GET_ALL_PHUONG,
  GET_ALL_QUAN,
  GET_ALL_DU_AN,
  GET_ALL_TEN_LOAI_DAT,
  GET_ALL_DU_AN_VKT
} from "./type";

export const getDataQuan = () => async (dispatch) => {
  let res = await AxiosGetSecretApi("/api/dia-chi/all-quan");
  let listQuan = [];
  if (res && Array.isArray(res) && res.length !== 0) {
    listQuan = res;
  }
  dispatch({
    type: GET_ALL_QUAN,
    payload: listQuan,
  });
};

export const getDataPhuong = () => async (dispatch) => {
  let res = await AxiosGetSecretApi("/api/dia-chi/all-phuong-quan");
  let listPhuong = [];
  if (res && Array.isArray(res) && res.length !== 0) {
    listPhuong = res;
  }
  dispatch({
    type: GET_ALL_PHUONG,
    payload: listPhuong,
  });
};

export const getDataDuong = () => async (dispatch) => {
  let res = await AxiosGetSecretApi("/api/dia-chi/all-duong");
  let listDuong = [];
  if (res && Array.isArray(res) && res.length !== 0) {
    listDuong = res;
  }
  dispatch({
    type: GET_ALL_DUONG,
    payload: listDuong,
  });
};

export const getDataLoaiPhongBan = () => async (dispatch) => {
  let res = await AxiosGetSecretApi("/api/group-user/all-loai-phong-ban");
  let listLoaiPhongBan = [];
  if (res && Array.isArray(res.data) && res.data.length !== 0) {
    listLoaiPhongBan = res.data;
  }
  dispatch({
    type: GET_ALL_LOAI_PHONG_BAN,
    payload: listLoaiPhongBan,
  });
};

export const getDataDuAn = () => async (dispatch) => {
  let res = await AxiosGetSecretApi("/api/duanqh/all")
  let listDuAn = [];
  if (res && Array.isArray(res) && res.length !== 0) {
    listDuAn = res;
  }
  dispatch({
    type: GET_ALL_DU_AN,
    payload: listDuAn,
  });
};

export const getDataDuAnVKT = () => async (dispatch) => {
  let res = await AxiosGetSecretApi("/api/vung-kien-truc/cbTenDuAn")
  let listDuAnVKT = [];
  if (res && Array.isArray(res) && res.length !== 0) {
    listDuAnVKT = res;
  }
  dispatch({
    type: GET_ALL_DU_AN_VKT,
    payload: listDuAnVKT,
  });
};

export const getDataTenLoaiDat = () => async (dispatch) => {
  let res = await AxiosGetSecretApi("/api/bang-mau/all")
  let listTenLoaiDat = [];
  if (res && Array.isArray(res) && res.length !== 0) {
    listTenLoaiDat = res;
  }
  dispatch({
    type: GET_ALL_TEN_LOAI_DAT,
    payload: listTenLoaiDat,
  });
};
